export interface RuntimeConfig {
  appSyncUrl: string;
  userPoolId: string;
  userPoolClientId: string;
  userPoolDomain: string;
  region: string;
}

let cached: RuntimeConfig | null = null;

export async function loadConfig(): Promise<RuntimeConfig> {
  if (cached) return cached;
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error('config.json missing');
  cached = (await res.json()) as RuntimeConfig;
  return cached;
}
